import { FormEvent } from "react";

import classes from "./addButton.module.scss";

interface Props {
  color?: string;
  onClick?: (event: FormEvent) => unknown;
  alternativeLook?: boolean;
  included?: boolean;
}

const AddButton = ({ color, onClick, alternativeLook, included }: Props) => {
  return (
    <button
      className={`${classes.button} ${color == "white" ? classes.white : ""} ${
        alternativeLook && classes.altLook
      } ${included && classes.included}`}
      onClick={onClick}
    >
      +
    </button>
  );
};

export default AddButton;
